import React, { useEffect, useState } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { Avatar } from "antd";
import SelectDialog from "./SelectDialog";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "@/langs/useTranslation";
import { getCompanyTreeAPI } from "@/apis/companyTreeApi";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(2),
    height: 35,
    padding: "7.5px 50px 7.5px 14px",
    verticalAlign: "middle",

    "&:hover .single-select-close": {
      visibility: "visible"
    }
  },
  noEmpty: {
    padding: 0,
    minWidth: 80,

    "& .default-value": {
      position: "absolute",
      left: 10,
      top: "50%",
      transform: "translateY(-50%)"
    }
  },
  small: {
    "& .MuiOutlinedInput-input": {
      paddingTop: 9.5,
      paddingBottom: 9.5,
      paddingRight: 50
    }
  },
  select: {
    position: "absolute",
    left: 0,
    top: 0
  },
  close: {
    position: "absolute",
    // right: 7,
    // top: -3,
    right: 26,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.text.secondary,
    fontSize: 16,
    cursor: "pointer",
    visibility: "hidden",
    zIndex: 10,

    "&:hover": {
      color: "#444"
    }
  },
  list: {
    marginTop: "20px",
    backgroundColor: "#f1f1f1",
    borderRadius: 5,
    padding: "10px 10px 0"
  },
  itemMain: {
    display: "inline-block",
    marginBottom: 8,
    marginRight: 15,
    borderRadius: 4,
    backgroundColor: "#fff",
    padding: "5px 10px"
  },
  item: {
    display: "flex",
    height: "30px",
    alignItems: "center"
  },
  itemText: {
    marginLeft: "8px",
    marginRight: "8px",
    flex: 1
  },
  deleteIcon: {
    cursor: "pointer",
    color: "#ccc",
    fontSize: 12
  }
}));

const SelectCompany = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectVisible, setSelectVisible] = useState(false);

  const [baseTreeData, setBaseTreeData] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [treeDataPool, setTreeDataPool] = useState({});

  const handleDelete = id => {
    onChange(value?.filter(item => item.receiverId !== id));
  };

  useEffect(() => {
    getCompanyTreeAPI().then(res => {
      setTreeData(res.companyTree);
      setBaseTreeData(res.companyTree);

      const map = {};
      res.flattenCompanyTree.forEach(item => {
        map[item.id] = item;
      });
      setTreeDataPool(map);
    });
  }, []);

  useEffect(() => {
    const pool = {};
    if (value && value.length > 0) {
      value.forEach(item => {
        item[item.receiverId] = {
          ...item,
          key: item.receiverId,
          name: item.receiverName
        };
      });
      setTreeDataPool(v => ({ ...v, ...pool }));
    }
  }, [value]);

  return (
    <div>
      {!disabled && (
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: "auto", height: 40 }}
          onClick={() => setSelectVisible(true)}
        >
          {t({ defaultMessage: "请选择指定用户" })}
        </Button>
      )}
      {!!value?.length && (
        <div className={classes.list}>
          {value?.map(receiver => (
            <div key={receiver.receiverId} className={classes.itemMain}>
              <div className={classes.item}>
                <Avatar
                  shape="square"
                  children={receiver.receiverName[0]}
                  style={{ backgroundColor: "#00afc6", borderRadius: 8 }}
                />
                <div className={classes.itemText}>{receiver.receiverName}</div>
                {!disabled && (
                  <CloseOutlined
                    className={classes.deleteIcon}
                    onClick={() => handleDelete(receiver.receiverId)}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      <SelectDialog
        onChange={onChange}
        value={value}
        setVisible={setSelectVisible}
        visible={selectVisible}
        onClose={() => {
          setSelectVisible(false);
          setTreeData(baseTreeData);
        }}
        treeData={treeData}
        setTreeData={setTreeData}
        treeDataPool={treeDataPool}
        setTreeDataPool={setTreeDataPool}
      />
    </div>
  );
};

export default SelectCompany;
